import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';

import type { MiniBagState } from '~/models';

export interface MiniBagContext {
  setMiniBagState: Dispatch<SetStateAction<Partial<MiniBagState>>>;
}

export const miniBagContext = createContext<MiniBagContext>({
  setMiniBagState: () => {},
});

export const MiniBagContextProvider = miniBagContext.Provider;
